import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { FormControl, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import { getGoodsCategoryById, goodsCategoryActions, updateGoodsCategory } from "../../../../redux/reducer/goodsCategory/goodsCategoryReducer";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdminGoodsCategoryEdit({ open, handleClose, id, clear }) {
  // Local State
  const [formData, setFormData] = useState({
    categoryName: "",
  });
  const [fetch, setFetch] = useState(true);

  // Redux State
  const dispatch = useDispatch();
  const data = useSelector((state) => state.goodsCategory.data.docs);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (fetch) {
      let x = data.findIndex((item) => item._id === id);
      if (x > -1) {
          setFormData({
              categoryName : data[x].categoryName ? data[x].categoryName : ""
          })
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan mohon refresh halaman / kontak developer anda",
        });
      }
      setFetch(false)
    }
  }, [fetch]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      token: token,
      value: formData,
      id: id
    };
    Swal.fire({
      title: `Periksa kembali data yang akan edit`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        dispatch(updateGoodsCategory(data)).then((res) => {
            if (res.payload.status === 200) {
              const getDataById = {
                token: token,
                id: res.payload.data._id,
              };
              dispatch(getGoodsCategoryById(getDataById)).then((res) => {
                dispatch(goodsCategoryActions.editGoodsCategory(res.payload.data));
                handleCloseModal();
                toast.success(res.payload.message);
              });
            } else {
              toast.error(res.payload.message);
              handleCloseModal();
            }
          });
      } else {
        setFormData({
          categoryName: "",
        });
      }
    });
  };

  const handleCloseModal = () => {
    clear();
    handleClose();
  }

  return (
    <>
      <ToastContainer />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseModal}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"EDIT DATA KATEGORI PRODUK"}</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent style={{ padding: "5px 24px" }}>
            <FormControl>
              <TextField
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{ maxLength: 50 }}
                size="small"
                error={false}
                label="NAMA KATEGORI PRODUK"
                value={formData.categoryName}
                name="categoryName"
                fullWidth
                variant="standard"
                style={{ width: "90vw", maxWidth: "400px" }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Submit</Button>
            <Button onClick={handleCloseModal} color="error">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

AdminGoodsCategoryEdit.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  clear: PropTypes.func,
  id: PropTypes.string
};
